var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconModifyOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2C2A29",
  d: "m13.926.868 1.625 1.534c.567.535.597 1.385.09 1.953l-.09.092-10.4 9.822a2.34 2.34 0 0 1-1.1.578l-3.11.69c-.412.09-.824-.15-.92-.54a.7.7 0 0 1 0-.33l.73-2.938a2.14 2.14 0 0 1 .611-1.038L11.76.868a1.596 1.596 0 0 1 2.166 0m-3.389 3.2-8.092 7.645a.7.7 0 0 0-.204.346l-.448 1.803 1.91-.423a.8.8 0 0 0 .366-.193l8.093-7.644zm2.306-2.177L11.62 3.045l1.625 1.534 1.223-1.154z"
})));
export { SvgIconModifyOn as ReactComponent };
export default __webpack_public_path__ + "img/icon-modify-on.52cb5741df8f820d17a9cd83ee18c8c9.svg";